/* eslint-disable @typescript-eslint/no-unused-vars */
import { NgModule } from '@angular/core';
import * as ModelUpdate from './_index';

@NgModule()
export class ModelUpdateModule {}
